export const SubmissionStatus = {
  PASS: "PASS",
  FAIL: "FAIL"
  // IN_PROGRESS: "INPROGRESS"
};
